import { render } from "./DialogPrivacyPolicy.vue?vue&type=template&id=55814561"
import script from "./DialogPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./DialogPrivacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__